<app-traitement-data titre="Fuites" [sousTitre]="patient!.fuites?.date | aLaDateDu"
    [statut]="patient!.fuites | fuitesStatut">
    {{ (patient!.fuites?.value | fuites) ?? 'Pas de donnée' }}
</app-traitement-data>